/* Scene groups use progressive enhancement; tag filters use Shopify's server-side URLs. */
class CatalogGroups extends HTMLElement {
  connectedCallback() {
    const filters = this.querySelector('.catalog-filters')
    if (!filters || filters.dataset.catalogFilterMode === 'tags') return
    filters.hidden = false
    this.onFilterClick ||= (event) => {
      const button = event.target.closest('button[data-catalog-filter]')
      if (!button || !this.contains(button)) return
      this.selectGroup(button.dataset.catalogFilter)
      const url = new URL(window.location.href)
      if (button.dataset.catalogFilter === 'all') url.searchParams.delete('scene')
      else url.searchParams.set('scene', button.dataset.catalogFilter)
      if (url.href !== window.location.href) window.history.pushState(null, '', url)
    }
    this.addEventListener('click', this.onFilterClick)
    this.onHistoryChange ||= () => this.selectFromUrl()
    window.addEventListener('popstate', this.onHistoryChange)
    this.selectFromUrl()
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.onHistoryChange)
    this.removeEventListener('click', this.onFilterClick)
  }

  selectFromUrl() {
    const requested = new URL(window.location.href).searchParams.get('scene')
    const exists = [...this.querySelectorAll('[data-catalog-filter]')].some(
      (button) => button.dataset.catalogFilter === requested,
    )
    this.selectGroup(exists ? requested : 'all')
  }

  selectGroup(selected) {
    this.querySelectorAll('[data-catalog-filter]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.catalogFilter === selected))
    })
    this.querySelectorAll('[data-catalog-group]').forEach((group) => {
      group.hidden =
        selected === 'all'
          ? group.dataset.empty === 'true'
          : group.dataset.catalogGroup !== selected
    })
    const empty = this.querySelector('[data-catalog-empty]')
    if (empty) empty.hidden = selected !== 'all'
  }
}
if (!customElements.get('catalog-groups')) customElements.define('catalog-groups', CatalogGroups)
